export const appConfig = {
  appName: 'RadioRat',
  tagline: 'Travel the world through live radio.',
  radioApiHosts: ['https://de1.api.radio-browser.info', 'https://fi1.api.radio-browser.info', 'https://nl1.api.radio-browser.info'],
  defaultLocation: { longitude: 18, latitude: 18, zoom: 1.65 },
  featureFlags: { journey: false, worldMixer: false, passport: true, achievements: true, postcards: false, soundEffects: false, genreMap: true },
} as const;
